const GiveawayService = {
  /**
   * Create a new giveaway for broadcast with {id} and {payload}
   * @param {String} id
   * @param {Object} payload
   * @returns {?Object}
   */
  create: async (id, payload) => {
    const { data } = await ovpFetch(`/giveaways?broadcast_id=${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
  /**
   * Fetch and return giveaways for broadcast with {id}
   * @param {String} id
   * @returns {Array}
   */
  list: async (id) => {
    const { data } = await ovpFetch(`/giveaways?broadcast_id=${id}`);
    return data;
  },
  /**
   * Fetch data for a specific giveaway with {id}
   * @param {String} id
   * @returns {Object}
   */
  get: async (id) => {
    const { data } = await ovpFetch(`/giveaways/${id}`);
    return data;
  },
  giveaways: async (payload) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');

    const { data, headers } = await ovpFetch(`/giveaways?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };
    let total = 0;

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }
    if (headers['total-count']) {
      total = headers['total-count'];
    }

    return {
      giveaways: data,
      pagination,
      total,
    };
  },
  /**
   * Delete a giveaway with {id}
   * @param {String} id
   * @returns {Boolean}
   */
  delete: async (id) => {
    await ovpFetch(`/giveaways/${id}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return true;
  },
  /**
   * Edit a giveaway with {id} and {payload}
   * @param {String} id
   * @param {Object} payload
   * @returns {?Object}
   */
  update: async (id, payload) => {
    await ovpFetch(`/giveaways/${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      iLikeItRaw: true,
    });
    return true;
  },
  /**
   * Roll a winner for giveaway with {id}
   * @param {String} id
   */
  rollWinner: async (id, winners) => {
    const { data } = await ovpFetch(`/giveaways/${id}/roll-winner`, {
      method: 'POST',
      body: JSON.stringify({
        ids: winners,
      }),
    });
    return data;
  },
  /**
   * Draw a winner for giveaway with {id}
   * @param {String} id
   */
  drawWinner: async (id, winners) => {
    await ovpFetch(`/giveaways/${id}/draw-winner`, {
      method: 'POST',
      iLikeItRaw: true,
      body: JSON.stringify({
        ids: winners,
      }),
    });
    return true;
  },
  /**
   * Update a giveaway with {id} with {state}
   * @param {String} id
   * @param {String} state
   */
  updateState: async (id, state) => {
    await ovpFetch(`/giveaways/${id}/state/${state}`, {
      method: 'POST',
      iLikeItRaw: true,
    });
    return true;
  },
  export: async (id) => {
    const { data } = await ovpFetch(`/app/giveaway/${id}/csv`, {
      iLikeItRaw: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { GiveawayService };
